
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1920","height":"873","viewBox":"0 0 1920 873","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#not-found-error-page_clip0)"}},[_c('path',{attrs:{"d":"M1920 -4H0V474H1920V-4Z","fill":"white"}}),_c('path',{attrs:{"d":"M1534.29 -57.9316L1030.74 265.653C1007.15 281.17 975.483 274.343 959.96 250.757C944.438 227.171 951.268 195.517 974.862 180L951.26 199.65C1012.73 159.306 1030.12 77.3761 990.377 15.929C950.019 -45.518 868.06 -62.897 806.59 -23.1737L-30.0012 510.691C-91.4705 551.035 -108.856 632.964 -68.4971 694.411C-28.1385 755.858 53.8206 773.237 115.29 733.514L435.291 541.643C458.885 526.126 490.551 532.953 506.074 556.539C521.596 580.125 514.766 611.779 491.172 627.296C407.153 686.04 331.324 738.626 395.5 836.5C482.932 969.842 712.842 690.5 846 690.5C942 690.5 1015.36 793.011 1091.5 769.5C1203.72 734.848 1211.08 825.661 1278 836.5C1333.28 845.453 1453.66 775.125 1491 753C1612.5 681.014 1629 672.5 1905.41 510.691C1972.47 467.243 2004.87 390.818 1961.41 324.406C1917.95 257.373 1841.44 257.373 1775 300.82L1738.37 324.406C1714.77 338.681 1534.5 453 1510.5 401C1486.5 349 1544.84 316.337 1568.44 300.82L1709.38 208.96C1783.27 160.547 1804.38 61.8591 1755.95 -12.0015C1707.52 -85.2414 1608.8 -106.344 1534.29 -57.9316Z","fill":"white"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"not-found-error-page_clip0"}},[_c('rect',{attrs:{"width":"1920","height":"873","fill":"white"}})])])])
          )
        }
      }
    